var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"rootEl",staticClass:"portfolio-jobs-inquiry-section"},[(_setup.hasJobsProfile)?_c(_setup.PortfolioJobsInquirySectionProfile,_vm._g({attrs:{"inquiry":_vm.inquiry,"user":_vm.user}},_vm.$listeners)):_c(_setup.PortfolioJobsInquirySectionEmpty)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }